<axis-ol-header></axis-ol-header>
<router-outlet></router-outlet>
<axis-ol-footer></axis-ol-footer>
<axis-ol-gv-redemption
  *ngIf="showRedemptionModal"
  [campaignId]="redemptionObj?.campaignId"
  [giftcard]="redemptionObj?.giftcard"></axis-ol-gv-redemption>
